import { GetDetailSaleResponse, SaleDetailGetAllResponseItem, SaleTip, UnitEnum } from '@esg/business-pos';

export const saleHelper = {
    calcSubTotal: (saleDetails: SaleDetailGetAllResponseItem[]) => {
        return saleDetails.reduce((acc, saleDetail) => {
            return acc + (saleDetail.isPaid ? 0 : saleDetail.totalAmount);
        }, 0);
    },
    calcSubTotalDetail: (saleDetails: SaleDetailGetAllResponseItem[]) => {
        return saleDetails.reduce((acc, saleDetail) => {
            return acc + (saleDetail.isPaid ? 0 : saleDetail.objectPrice * saleDetail.quantity);
        }, 0);
    },
    calcTotalDiscount: (saleDetails: SaleDetailGetAllResponseItem[]) => {
        return saleDetails.reduce((acc, saleDetail) => {
            return acc + (saleDetail.isPaid ? 0 : (saleDetail.objectPrice * saleDetail.quantity - saleDetail.totalAmount));
        }, 0);
    },
    calcTipAmountTemp: (subTotal: number, tipUnit: UnitEnum, tip: number) => {
        if (tipUnit === UnitEnum.Percent) {
            return subTotal * tip / 100;
        }
        else if (tipUnit === UnitEnum.Amount) {
            return tip;
        }

        return 0;
    },
    calcTipAmount: (sale?: GetDetailSaleResponse) => {
        if (sale?.tipUnit === UnitEnum.Percent) {
            return (sale?.subTotal ?? 0) * (sale.tip ?? 0) / 100;
        }
        else if (sale?.tipUnit === UnitEnum.Amount) {
            return sale?.tip;
        }

        return 0;
    },
    calcUpdateTipAmount: (sale?: GetDetailSaleResponse, subTotal?: number) => {
        if (sale?.tipUnit === UnitEnum.Percent) {
            return (subTotal ?? 0) * (sale.tip ?? 0) / 100;
        }
        else if (sale?.tipUnit === UnitEnum.Amount) {
            return sale?.tip;
        }

        return 0;
    },
    calcDiscountAmount: (saleDetails: SaleDetailGetAllResponseItem[]) => {
        return saleDetails?.reduce((acc, saleDetail) => {
            let discountAmount = 0;

            if (saleDetail.discountUnit === UnitEnum.Percent) {
                discountAmount == ((saleDetail.discount ?? 0) * saleDetail.objectPrice);
            }
            else {
                discountAmount += saleDetail.discount ?? 0;
            }

            return acc + (saleDetail.isPaid ? 0 : discountAmount);
        }, 0) ?? 0;
    },
    calcTaxAmount: (saleDetails: SaleDetailGetAllResponseItem[]) => {
        return saleDetails?.reduce((acc, saleDetail) => {
            return acc + saleDetail.taxAmount;
        }, 0) ?? 0;
    },
    updateCurrentSale: (currentSale: GetDetailSaleResponse, saleDetails: SaleDetailGetAllResponseItem[]) => {
        const taxAmount = saleHelper.calcTaxAmount(saleDetails);
        const subTotal = saleHelper.calcSubTotal(saleDetails);
        const tipAmount = saleHelper.calcUpdateTipAmount(currentSale, subTotal);

        return {
            ...currentSale,
            saleDetails: saleDetails,
            subTotal: saleHelper.calcSubTotal(saleDetails),
            taxAmount: saleHelper.calcTaxAmount(saleDetails),
            totalAmount: subTotal + taxAmount + tipAmount,
        };
    },
    distributeTips(sale: GetDetailSaleResponse): SaleTip[] {
        const saleDetails = (sale.saleDetails ?? []);

        const saleTip = saleHelper.calcTipAmount(sale);

        const totalSaleDetailAmount = saleDetails.reduce(
            (sum, d) => sum + d.totalAmount,
            0
        );

        const employeeTips: Record<string, number> = {};

        for (const detail of saleDetails) {
            if (!detail.saleDetailEmployees?.length) continue;

            const detailRatio = detail.totalAmount / totalSaleDetailAmount;
            const tipForDetail = saleTip * detailRatio;
            const eachEmployeeTip = tipForDetail / detail.saleDetailEmployees.length;

            for (const emp of detail.saleDetailEmployees) {
                if (!employeeTips[emp.employeeId]) employeeTips[emp.employeeId] = 0;
                employeeTips[emp.employeeId] += eachEmployeeTip;
            }
        }

        return Object.entries(employeeTips).map(([employeeId, tipAmount]) => ({
            employeeId,
            tipAmount,
            saleId: sale.id,
        }));
    },
    distributeNewTips(sale: GetDetailSaleResponse, saleTip: number): SaleTip[] {
        const saleDetails = (sale.saleDetails ?? []);

        const totalSaleDetailAmount = saleDetails.reduce(
            (sum, d) => sum + d.totalAmount,
            0
        );

        const employeeTips: Record<string, number> = {};

        for (const detail of saleDetails) {
            if (!detail.saleDetailEmployees?.length) continue;

            const detailRatio = detail.totalAmount / totalSaleDetailAmount;
            const tipForDetail = saleTip * detailRatio;
            const eachEmployeeTip = tipForDetail / detail.saleDetailEmployees.length;

            for (const emp of detail.saleDetailEmployees) {
                if (!employeeTips[emp.employeeId]) employeeTips[emp.employeeId] = 0;
                employeeTips[emp.employeeId] += eachEmployeeTip;
            }
        }

        return Object.entries(employeeTips).map(([employeeId, tipAmount]) => ({
            employeeId,
            tipAmount,
            saleId: sale.id,
        }));
    }
};